// extracted by mini-css-extract-plugin
export default {"root":"AddDocumentToggle_root__VmnIm"};